<template>
  <section class="section__cuna">
    <!-- Floating case study on right top -->
    <FloatingCaseStudy :caseColor="caseColor" :caseText="caseText"></FloatingCaseStudy>
    <!-- All animating objects -->
    <div class="section__cuna--bg"></div>
  </section>
</template>

<script>
// Import small components
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";
export default {
  name: "ComponentCunaSportswear",
  data() {
    return {};
  },
  props: ["showChild", "activeSection"],
  mounted: function() {},
  methods: {},

  // Init components
  components: {
    SectionTitle: SectionTitle,
    FloatingSocials: FloatingSocials
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentCunaSportwear.vue